<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps<{ error: NuxtError }>();

const errorDetails = computed(
  () => props.error?.statusMessage || props.error?.message || "404"
);
</script>

<template>
  <main
    class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8"
  >
    <div class="text-center">
      <h1
        class="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl"
      >
        Page or Assessment not found
      </h1>
      <p
        class="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8"
      >
        Sorry, we couldn’t find the page you’re looking for.
      </p>
    </div>
  </main>
</template>

<style>
html {
  @apply h-full;
}

body {
  @apply h-full;
}
</style>
